<template>
  <div class="skill__content">
    <p>
      Print, Digital, Icons, Illustration, Layout, etc.
    </p>
  </div>
</template>
